module.exports = __webpack_public_path__ + "img/leona_parkhaus_sitzend_ocular.3b70f986.jpg";